export default __webpack_public_path__ + "media/error-bg.b55b0ce1.jpg";